import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=0ca87508&scoped=true"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"
import style0 from "./Warning.vue?vue&type=style&index=0&id=0ca87508&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca87508",
  null
  
)

export default component.exports